export enum TemplateTabEnum {
  DETAILS = 'details',
  INVITATION = 'invitation',
  DOCUMENTS = 'documents',
  RULES = 'rules'
}

export type TemplateTab = {
  value: TemplateTabEnum;
  label: string;
};

export const TEMPLATE_TABS: TemplateTab[] = [
  { value: TemplateTabEnum.DETAILS, label: 'Inspection Details' },
  { value: TemplateTabEnum.INVITATION, label: 'Invitation Message' },
  { value: TemplateTabEnum.DOCUMENTS, label: 'Documents & Verifications' },
  { value: TemplateTabEnum.RULES, label: 'Lender Criteria Rules' }
];

export const isTemplateTab = (
  value?: string | null
): value is TemplateTabEnum => TEMPLATE_TABS.some((tab) => tab.value === value);

export const getTemplateTabIndex = (tab: TemplateTabEnum): number =>
  TEMPLATE_TABS.findIndex((item) => item.value === tab);

// Maps a validation field name to the tab that owns it, so a failed save can
// bring the offending control back on screen.
export const TEMPLATE_TAB_BY_FIELD: Record<string, TemplateTabEnum> = {
  name: TemplateTabEnum.DETAILS,
  description: TemplateTabEnum.DETAILS,
  notificationEmails: TemplateTabEnum.DETAILS,
  inspectionMessage: TemplateTabEnum.INVITATION,
  selectedDocuments: TemplateTabEnum.DOCUMENTS,
  approverEmails: TemplateTabEnum.RULES
};

export const getTemplateTabForField = (field: string): TemplateTabEnum =>
  TEMPLATE_TAB_BY_FIELD[field] || TemplateTabEnum.DETAILS;
